<template>
  <div class="control-btn-cont">
    <p class="btn-label">{{$t('btns.things.import')}}</p>
    <button type="button" class="btn btn-control circle-btn btn-light-blue">
      <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M29.3416 19.2667V28.3333C29.3416 29.2667 28.6083 30 27.6749 30H2.34159C1.40826 30 0.674927 29.2667 0.674927 28.3333V19.2667C0.674927 18.3334 1.40826 17.6 2.34159 17.6C3.27493 17.6 4.00826 18.3334 4.00826 19.2667V26.6667H26.0083V19.2667C26.0083 18.3334 26.7416 17.6 27.6749 17.6C28.6083 17.6 29.3416 18.3334 29.3416 19.2667ZM9.54159 9.6333L13.3416 5.76668V20.2C13.3416 21.1334 14.0749 21.8667 15.0083 21.8667C15.9416 21.8667 16.6749 21.1334 16.6749 20.2V5.76668L20.4749 9.6333C20.8082 9.96663 21.2416 10.1333 21.6749 10.1333C22.1083 10.1333 22.5083 9.96667 22.8416 9.66667C23.5083 9.03333 23.5083 7.96663 22.875 7.29997L16.2416 0.5C15.9416 0.166667 15.5083 0 15.0416 0C14.6083 0 14.1749 0.166667 13.8416 0.5L7.20825 7.29997C6.57492 7.96663 6.57491 9 7.24158 9.66667C7.84158 10.3 8.90825 10.2666 9.54159 9.6333Z" fill="#F5F8FA"/>
      </svg>
    </button>
  </div>
</template>

<script>
  export default {
    name: 'importThing'
  }
</script>

